"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformManualIncentives = exports.transformToBaseIncentive = exports.isOriginalIncentive = exports.isNotDealerCash = exports.isDealerCash = exports.getIncentiveSum = exports.transformToManualEditIncentive = void 0;
var manualIncentiveConsts_1 = require("../shared/consts/manualIncentiveConsts");
var transformToManualEditIncentive = function (incentive) {
    var _a;
    var result = __assign(__assign(__assign({}, incentive), ('category' in incentive && {
        category: incentive.category
    })), { type: incentive.type, originalAmount: incentive.originalAmount || incentive.amount, deleted: (_a = incentive.deleted) !== null && _a !== void 0 ? _a : false });
    return result;
};
exports.transformToManualEditIncentive = transformToManualEditIncentive;
/**
 *
 * @param incentives: all manual incentives
 * @returns total value of all incentives not including those flagged for deletion.
 */
var getIncentiveSum = function (incentives) {
    return incentives.reduce(function (total, _a) {
        var amount = _a.amount, deleted = _a.deleted;
        if (!deleted) {
            // tslint:disable-next-line: no-parameter-reassignment
            return (total += amount);
        }
        return total;
        // tslint:disable-next-line: align
    }, 0);
};
exports.getIncentiveSum = getIncentiveSum;
var isDealerCash = function (_a) {
    var type = _a.type;
    return type === 'DealerCash';
};
exports.isDealerCash = isDealerCash;
var isNotDealerCash = function (_a) {
    var type = _a.type;
    return type !== 'DealerCash';
};
exports.isNotDealerCash = isNotDealerCash;
var isOriginalIncentive = function (type) { return [manualIncentiveConsts_1.INCLUDED, manualIncentiveConsts_1.MANUFACTURER, manualIncentiveConsts_1.LENDER].includes(type); };
exports.isOriginalIncentive = isOriginalIncentive;
var transformToBaseIncentive = function (incentive, updateManualIncentivesMV) {
    var _a;
    if (updateManualIncentivesMV === void 0) { updateManualIncentivesMV = false; }
    var mappedIncentive = {
        amount: incentive.amount,
        code: incentive.code || incentive.pdId,
        conditionCategory: incentive.conditionCategory,
        description: incentive.description,
        endDate: incentive.endDate,
        exclusions: incentive.exclusions,
        financeMethod: incentive.financeMethod,
        fundingSource: incentive.fundingSource,
        isStandardIncentive: Boolean(incentive.isStandardIncentive),
        manual: updateManualIncentivesMV ? (_a = incentive.manual) !== null && _a !== void 0 ? _a : true : true,
        name: incentive.name,
        program: incentive.program || incentive.programId,
        programType: incentive.programType,
        startDate: incentive.startDate,
        termRebates: incentive.termRebates,
        type: incentive.type || incentive.incentiveType
    };
    Object.keys(mappedIncentive)
        .filter(function (prop) { return mappedIncentive[prop] == null; })
        .forEach(function (prop) { return delete mappedIncentive[prop]; });
    return mappedIncentive;
};
exports.transformToBaseIncentive = transformToBaseIncentive;
var transformManualIncentives = function (manualIncentives) {
    var incentives = manualIncentives === null || manualIncentives === void 0 ? void 0 : manualIncentives.incentives;
    if (incentives) {
        manualIncentives.incentives = incentives.map(function (incentive) { return (0, exports.transformToBaseIncentive)(incentive); });
    }
};
exports.transformManualIncentives = transformManualIncentives;
